//
// Copyright (C) 2021 The Android Open Source Project
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

// @generated by protoc-gen-es v2.7.0 with parameter "target=ts,import_extension=none"
// @generated from file android/hardware/automotive/vehicle/VehiclePropertyAccess.proto (package android.hardware.automotive.vehicle.proto, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file android/hardware/automotive/vehicle/VehiclePropertyAccess.proto.
 */
export const file_android_hardware_automotive_vehicle_VehiclePropertyAccess: GenFile = /*@__PURE__*/
  fileDesc("Cj9hbmRyb2lkL2hhcmR3YXJlL2F1dG9tb3RpdmUvdmVoaWNsZS9WZWhpY2xlUHJvcGVydHlBY2Nlc3MucHJvdG8SKWFuZHJvaWQuaGFyZHdhcmUuYXV0b21vdGl2ZS52ZWhpY2xlLnByb3RvKkYKFVZlaGljbGVQcm9wZXJ0eUFjY2VzcxIICgROT05FEAASCAoEUkVBRBABEgkKBVdSSVRFEAISDgoKUkVBRF9XUklURRADYgZwcm90bzM");

/**
 * Must be in sync with VehiclePropertyAccess.aidl. 
 *
 * @generated from enum android.hardware.automotive.vehicle.proto.VehiclePropertyAccess
 */
export enum VehiclePropertyAccess {
  /**
   * @generated from enum value: NONE = 0;
   */
  NONE = 0,

  /**
   * @generated from enum value: READ = 1;
   */
  READ = 1,

  /**
   * @generated from enum value: WRITE = 2;
   */
  WRITE = 2,

  /**
   * @generated from enum value: READ_WRITE = 3;
   */
  READ_WRITE = 3,
}

/**
 * Describes the enum android.hardware.automotive.vehicle.proto.VehiclePropertyAccess.
 */
export const VehiclePropertyAccessSchema: GenEnum<VehiclePropertyAccess> = /*@__PURE__*/
  enumDesc(file_android_hardware_automotive_vehicle_VehiclePropertyAccess, 0);

